import { render, staticRenderFns } from "./HeroImage.vue?vue&type=template&id=c35c457e&"
import script from "./HeroImage.vue?vue&type=script&lang=js&"
export * from "./HeroImage.vue?vue&type=script&lang=js&"
import style0 from "./HeroImage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports